import * as dataLayerConstants from '../../../analytics/src/datalayer/constants';
import initContentReadingTracking from '../../../analytics/src/datalayer-content-reading-tracking';

export const payWallEndBannerDisplayed = messageParts => {
	sessionStorage.setItem( 'rtaSameDomain', 'true' );

	const body = document.querySelector( 'body' );
	body.classList.add( 'piano-inline-checkout' );

	const gaLabel = messageParts[ 1 ];
	if ( dataLayer ) {
		const paywallIdentifier = 'paywallImpression1';
		const paywallImpressionObject = {};
		paywallImpressionObject.event = paywallIdentifier;
		paywallImpressionObject[ `event_action_${paywallIdentifier}` ] = 'impression';
		paywallImpressionObject[ `event_label_${paywallIdentifier}` ] = gaLabel;
		paywallImpressionObject[ `piano_label_${paywallIdentifier}` ] = gaLabel;
		paywallImpressionObject[ `service_platform_${paywallIdentifier}` ] =
			dataLayerConstants.SERVICE_PLATFORM_PIANO;
		dataLayer.push( paywallImpressionObject );
	}

	window.paywallDisplayed = 'Subscription';

	const payWallDisplayed = new CustomEvent( 'payWallDisplayed' );
	window.dispatchEvent( payWallDisplayed );

	initContentReadingTracking();
};

export default payWallEndBannerDisplayed;
